/**
 * Thin wrappers around Capacitor. Everything under src/native/ has a web
 * fallback, so the browser build never depends on a native runtime.
 */
import { Capacitor } from '@capacitor/core'

export const isNative = (): boolean => Capacitor.isNativePlatform()
export const platform = (): 'ios' | 'android' | 'web' =>
  Capacitor.getPlatform() as 'ios' | 'android' | 'web'
export const hasPlugin = (name: string): boolean => Capacitor.isPluginAvailable(name)
